export default __webpack_public_path__ + "static/media/CM.b804cbad.ico";